import { createSlice } from "@reduxjs/toolkit";
import { IPerson } from "../interface/IPerson";

const initialState: IPerson | null = null;

const clientSlice = createSlice({
    name: "client",
    initialState,
    reducers: {
        setClientStore: (state: string | null, action: any | null) => {
            return action.payload;
        },
    },
});

export const { setClientStore } = clientSlice.actions;

export default clientSlice.reducer;